import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  Typography,
} from "@repo/ui";
import DownloadBrochureForm from "../forms/DownloadBrochureForm";
import { getCookie } from "cookies-next";
import { useState } from "react";
import { Download } from "lucide-react";

const NoScheduleCartDownloadSyllabus = () => {
  const [open, setOpen] = useState(false);

  const cookieValue = getCookie("serviceId");
  const serviceId =
    cookieValue !== undefined &&
    cookieValue !== "" &&
    !isNaN(Number(cookieValue))
      ? Number(cookieValue)
      : undefined;

  return (
    <Card outlined className="!border-primary-main ">
      <CardHeader heading="Schedule not yet released" />
      <CardContent>
        <Typography paragraph>
          Discover the course curriculum and learning objectives by downloading
          the syllabus.
        </Typography>
        <Button
          color="secondary"
          fullWidth
          endIcon={<Download size={20} />}
          onClick={() => setOpen(true)}
        >
          Download Syllabus
        </Button>
      </CardContent>
      {/* Download course brochure popup */}
      <Dialog open={open} onOpenChange={setOpen} maxWidth="md" className="!p-0">
        <DownloadBrochureForm
          formType="COURSE_DOWNLOAD_BROCHURE"
          serviceId={serviceId}
          heading="Download Syllabus"
        />
      </Dialog>
    </Card>
  );
};

export default NoScheduleCartDownloadSyllabus;
